import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth"

import { auth, actionCodeSettings } from "./auth"

import type { UserCredential } from "firebase/auth"

export const signUpWithEmailAndPassword = async (
  email: string,
  password: string,
): Promise<UserCredential> => {
  return await createUserWithEmailAndPassword(auth, email, password)
}
export const sendEmailToVerify = async () => {
  if (!auth.currentUser) return
  return await sendEmailVerification(auth.currentUser, actionCodeSettings)
}

export const logInWithEmailAndPassword = async (
  email: string,
  password: string,
): Promise<UserCredential> => {
  return await signInWithEmailAndPassword(auth, email, password)
}
